// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609171904/js/" + chunkId + "." + {"44":"2a640856","225":"de175799","481":"93000732","486":"8b8489c5","770":"de2817ea"}[chunkId] + ".0.06538771746492478.chunk.js";
};